import { FC } from 'react';

import { Chip, Stack, Tooltip, Typography } from '@mui/material';

type TitleProps = {
  status: string;
  transactionId: string;
  transactionType: string;
  transactionCreated: string;
};

const Title: FC<TitleProps> = ({
  status,
  transactionId,
  transactionType,
  transactionCreated,
}) => {
  const transactionIdFirstPart = transactionId.split('-')[0];

  return (
    <Stack
      direction='row'
      sx={{ justifyContent: 'space-between', alignItems: 'center' }}
    >
      <Stack>
        <Tooltip title={transactionId} placement='right' arrow>
          <Typography
            variant='h5'
            sx={{
              display: 'inline-block',
              textTransform: 'uppercase',
              width: 'fit-content',
            }}
          >
            {transactionIdFirstPart}
          </Typography>
        </Tooltip>
        
        <Typography
          variant='caption'
          noWrap
          sx={{
            color: 'text.secondary',
          }}
        >
          {transactionCreated}
        </Typography>
      </Stack>

      <Stack direction='row' spacing={1.5}>
        <Chip size='medium' label={transactionType} />
        <Chip size='medium' label={status} />
      </Stack>
    </Stack>
  );
};

export default Title;
